import Settings from '../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 70,
    TINT: 0xffffff,
};

export default class Title extends Phaser.GameObjects.Container {
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupLabel();
    }

    setupLabel() {
        this.label = this.scene.add.bitmapText(0, 0, LABEL.FONT,  this.scene.cache.json.get('i18n')['friends'], LABEL.SIZE);
        this.label.setOrigin(0.5);
        this.label.setTint(LABEL.TINT);
        this.add(this.label);
    }
}
